var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-5 ml-2",attrs:{"rounded":"","color":"primary","dark":"","large":""},on:{"click":_vm.action}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" mdi-refresh ")])],1)]}}])},[_vm._v(" Refresh ")])}
var staticRenderFns = []

export { render, staticRenderFns }